import { render, staticRenderFns } from "./ContentTitle.vue?vue&type=template&id=298dbc20&scoped=true&"
import script from "./ContentTitle.vue?vue&type=script&lang=js&"
export * from "./ContentTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298dbc20",
  null
  
)

export default component.exports